import type { MonthAtGlanceInsightsDTO } from "../models/monthAtGlanceInsightsDto";
import type { MonthAtGlanceInsightsEntity } from "../../domain/entities/MonthAtGlanceInsightsEntity";

export function monthAtGlanceInsightsDtoToEntity(
  dto: MonthAtGlanceInsightsDTO,
): MonthAtGlanceInsightsEntity {
  return {
    insights: (dto.insights ?? []).map((item) => ({
      accentColor: item.accentColor ?? "neutral",
      title: item.title ?? "",
      description: item.description ?? "",
    })),
    noInsights: dto.no_insights ?? false,
    monthLabel: dto.month_label ?? "",
    message: dto.message ?? null,
  };
}
